import React from 'react'
import PropTypes from 'prop-types'
import Layout from 'src/components/layouts'
import FaqRepository from 'src/repositories/FaqRepository'
import FaqPage from 'src/components/pages/BrandPages/Faq'
import logger from 'src/common/logger'

export async function getServerSideProps({ preview }) {
  let faqs = []
  try {
    faqs = await FaqRepository.getInstance().getModels(
      {
        'fields.isFaqEnabled[exist]': true,
        'fields.isFaqEnabled': true,
      },
      preview
    )
  } catch (error) {
    logger.error('FAQ page: can not get faqs', { error })
  }

  const faqsFinal = faqs.map((el) => {
    return {
      ...el,
      title: el.question,
      content: el.answer,
    }
  })
  delete faqsFinal.question
  delete faqsFinal.answer

  return {
    props: {
      faqs: faqsFinal,
    },
  }
}

const Faq = ({ faqs }) => {
  return (
    <Layout isBrandPage={true}>
      <FaqPage faqs={faqs} />
    </Layout>
  )
}

Faq.propTypes = {
  faqs: PropTypes.array.isRequired,
}

export default Faq
